import React from 'react';

import {errorPage, errorPageSubtitle, errorPageTitle} from './error-page.component.module.styl';

type Props = {
    title: string,
    subtitle: string,
    mix: string,
};


const ErrorPage = (props: Props) => {
    const {title, subtitle, mix} = props;

    return (
        <div className={`${errorPage} ${mix}`}>
            <div className={errorPageTitle}>
                {title}
            </div>
            <div className={errorPageSubtitle}>
                {subtitle}
            </div>
        </div>
    );
};

ErrorPage.defaultProps = {
    title: '',
    subtitle: '',
    mix: '',
};

export default ErrorPage;
